/** Update before every release. version must match src/assets/version.json. */
export const appVersion = {
  version: '1.0.2',
  showWhatsNew: false,
  features: [] as string[]
};
